import useLanguage from '@/utils/hooks/useLanguage';
import useOrderExecution from '@/utils/hooks/useOrderExecution';
import { Tab } from '@headlessui/react';
import { useMemo } from 'react';
import ModuleTabs from '../common/ModuleTab';
import LimitOrderForm from '../form/LimitOrderForm';
import MarketOrderForm from '../form/MarketOrderForm';
import OcoOrderForm from '../form/OcoOrderForm';
import StopOrderForm from '../form/StopOrderForm';

interface OrderExecutionProps {}

export default function OrderExecution(props: OrderExecutionProps) {
    const lang = useLanguage();

    const orderExecutionProps = useOrderExecution();

    const tabs = useMemo(() => {
        return [
            lang.orderForm.marketOrder,
            lang.orderForm.limitOrder,
            lang.orderForm.stopOrder,
            lang.orderForm.ocoOrder
        ];
    }, [lang]);

    return (
        <div className="flex flex-col h-full" dir={lang.dir}>
            <Tab.Group>
                <ModuleTabs.Main tabs={tabs} />
                <Tab.Panel className="flex-1 overflow-y-auto">
                    <MarketOrderForm {...orderExecutionProps} />
                </Tab.Panel>
                <Tab.Panel className="flex-1 overflow-y-auto">
                    <LimitOrderForm {...orderExecutionProps} />
                </Tab.Panel>
                <Tab.Panel className="flex-1 overflow-y-auto">
                    <StopOrderForm {...orderExecutionProps} />
                </Tab.Panel>
                <Tab.Panel className="flex-1 overflow-y-auto">
                    <OcoOrderForm {...orderExecutionProps} />
                </Tab.Panel>
            </Tab.Group>
        </div>
    );
}
